import type { QuoteCreatePayload } from './fixtures';
import type { DupeCheckParams } from '../../services/quote.service';

/** Build the duplicate check using the selected quote type’s lane identity. */
export function dupeParamsFromDraft(d: QuoteCreatePayload): DupeCheckParams {
  if (d.header.quotetype === 'WAREHOUSE') {
    const t = d.transload;
    return {
      quotetype: 'WAREHOUSE', billto: d.header.billto, billtoname: d.header.billtoname ?? '',
      movetype: t?.movetype ?? '', whsetype: t?.whsetype ?? '', packagetype: t?.packagetype ?? '',
      ratezone: t?.ratezone ?? '', warehouse: t?.warehouse ?? '', size: t?.size ?? '', equiptype: t?.equiptype ?? '',
    };
  }
  const dir = d.direct ?? ({} as NonNullable<QuoteCreatePayload['direct']>);
  return {
    quotetype: d.header.quotetype || 'DIRECT',
    billto: d.header.billto,
    billtoname: d.header.billtoname ?? '',
    ratezone: dir.ratezone ?? '',
    deliveryzone: dir.deliveryzone ?? '',
    delivertozip: dir.delivertozip ?? '',
    delivertocity: dir.delivertocity ?? '',
    delivertostate: dir.delivertostate ?? '',
  };
}
